import { Navigate, useLocation } from 'react-router-dom';

/** Map legacy /makeup-hair/* bookmarks to /makeup/*. */
export function MakeupHairLegacyRedirect({ toBase = '/makeup' }) {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/makeup-hair/, '') || '';
  const target = `${toBase}${rest}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}

/** Map legacy /enterprise/makeuphair/* to /enterprise/looks/*. */
export function EnterpriseMakeupHairLegacyRedirect({ toBase = '/enterprise/makeup-studio-test' }) {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/enterprise\/makeuphair/, '') || '';
  const target = `${toBase}${rest}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}

/** Map legacy /nyafaz-ep/makeup-studio-test/* and /nyafaz-ep/makeup-flux-prompt-v3/* to /nyafaz-ep/makeup/*. */
export function NyafazEpLegacyMakeupRedirect({ toBase = '/nyafaz-ep/makeup' }) {
  const location = useLocation();
  let rest = '';
  if (location.pathname.startsWith('/nyafaz-ep/makeup-flux-prompt-v3')) {
    rest = location.pathname.replace(/^\/nyafaz-ep\/makeup-flux-prompt-v3/, '') || '/studio';
  } else {
    rest = location.pathname.replace(/^\/nyafaz-ep\/makeup-studio-test/, '') || '/capture';
  }
  const suffix = rest.startsWith('/') ? rest : `/${rest}`;
  const target = `${toBase}${suffix}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}

/** Map legacy /nyafaz-ep/hair-coloring-test/* and /nyafaz-ep/hair-color/* to /nyafaz-ep/hair-coloring/*. */
export function NyafazEpLegacyHairColoringRedirect({ toBase = '/nyafaz-ep/hair-coloring' }) {
  const location = useLocation();
  const rest =
    location.pathname
      .replace(/^\/nyafaz-ep\/hair-coloring-test/, '')
      .replace(/^\/nyafaz-ep\/hair-color/, '') || '/capture';
  const suffix = rest.startsWith('/') ? rest : `/${rest}`;
  const target = `${toBase}${suffix}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}

/** Map legacy /nyafaz-ep/haircut/* to /nyafaz-ep/hair-styling/*. */
export function NyafazEpLegacyHairStylingRedirect({ toBase = '/nyafaz-ep/hair-styling' }) {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/nyafaz-ep\/haircut/, '') || '/capture';
  const suffix = rest.startsWith('/') ? rest : `/${rest}`;
  const target = `${toBase}${suffix}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}

/** Map legacy /enterprise/makeup/* to /enterprise/looks/*. */
export function EnterpriseMakeupToLooksRedirect({ toBase = '/enterprise/makeup-studio-test' }) {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/enterprise\/makeup/, '') || '';
  const target = `${toBase}${rest}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}

/** Map legacy /enterprise/hair-coloring(|-test)/* to /enterprise/hair-coloring/*. */
export function EnterpriseHairColoringTestRedirect({ toBase = '/enterprise/hair-coloring' }) {
  const location = useLocation();
  const rest =
    location.pathname
      .replace(/^\/enterprise\/hair-coloring-test/, '')
      .replace(/^\/enterprise\/hair-coloring/, '') || '';
  const suffix = rest || '/capture';
  const target = `${toBase}${suffix}${location.search || ''}${location.hash || ''}`;
  return <Navigate to={target} replace />;
}
